import React from "react";

const Main = () => {
    return (
        <main className="main">
            <h1>We are:</h1>
            <ul>
                <li>Using the world’s advanced robokit which developed for Children</li>
                <li>Small class teaching (No more than 6 students with 2 teachers for each group</li>
                <li>A team of professional teachers with education, psychology, science and engineering background</li>
                <li>​Excellent service for each child and parents.</li>
            </ul>
        </main>
    )
}

export default Main;
